import angular from 'angular';
import template from './async-email-input.html';
import asyncEmailValidation from '../../validators/async-email/async-email';
import { STATES } from '../../../../constants';
import './async-email-input.global.css';

export default angular
  .module('app.directives.aysnc-email', [asyncEmailValidation.name])
  .directive('asyncEmailInput', directive);

function directive() {
  return {
    restrict: 'E',
    template,
    link,
    scope: {
      emailModel: '=ngModel',
      form: '=?',
      inviteToken: '@?',
    },
  };

  function link(scope, element, attrs) {
    scope.isRequired = attrs.required;
    scope.signIn = STATES.SIGN_IN;
  }
}
